<template>
  <div>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item has-feedback label="Module" prop="module">
        <a-select
          placeholder="Choose module"
          style="width: 100%;"
          v-model="form.module"
        >
          <a-select-option v-for="item in modules" :key="item" :value="item">
            {{ item }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item
        has-feedback
        label="Days Added Default In Deadline"
        prop="daysAddedDefaultInDeadline"
      >
        <a-input-number
          v-model="form.daysAddedDefaultInDeadline"
          placeholder="Số ngày mặc định cộng thêm vào deadline..."
          :formatter="
            (value) =>
              +value >= 0
                ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : undefined
          "
          :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
          style="width: 100%;"
        />
      </a-form-model-item>
      <a-form-model-item label="Remind Before" prop="remindBefore">
        <a-input-number
          v-model="form.remindBefore"
          placeholder="Số ngày thông báo trước deadline..."
          :formatter="
            (value) =>
              +value >= 0
                ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : undefined
          "
          :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
          style="width: 100%;"
        />
      </a-form-model-item>
    </a-form-model>

    <div
      style="text-align: right;"
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button @click="closeDrawerAddReminder" style="margin-right: 5px;">
        Close
      </a-button>
      <a-button type="primary" @click="createReminder()" :loading="iconLoading">
        Create
      </a-button>
    </div>
  </div>
</template>
<script>
import postQuery from "../../data/postData";
export default {
  props: {
    closeDrawerAddReminder: {
      type: Function,
      default: null,
    },
    createdReminderOnView: {
      type: Function,
    },
  },
  data() {
    return {
      iconLoading: false,
      form: {
        daysAddedDefaultInDeadline: null,
        remindBefore: null,
      },
      modules: [],
      rules: {
        module: [
          {
            required: true,
            message: "Required",
            trigger: "change",
          },
        ],
        daysAddedDefaultInDeadline: [
          {
            required: true,
            message: "Required",
            trigger: "change",
          },
        ],
        remindBefore: [
          {
            required: true,
            message: "Required",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    getModulesNameReminder() {
      this.$apollo
        .query({
          query: postQuery.getAppConfigReminderModulesName,
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          this.modules = data.getAppConfigReminderModulesName;
          this.loading = false;
        })
        .catch((error) => {
          this.$notification.error({
            message: "Thông báo",
            description: "Không lấy được chi tiết cấu hình",
          });
          console.log("Không lấy được chi tiết cấu hình", error);
        });
    },
    createReminder() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.iconLoading = true;
          this.$apollo
            .mutate({
              mutation: postQuery.createAppConfigReminder,
              fetchPolicy: "no-cache",
              variables: {
                ...this.form,
              },
            })
            .then(({ data }) => {
              if (data?.createAppConfigReminder) {
                this.$notification.success({
                  message: "Thông báo",
                  description: "Thêm cấu hình thành công !",
                });
                this.createdReminderOnView(data.createAppConfigReminder);
              }
              this.iconLoading = false;
              this.closeDrawerAddReminder();
            })
            .catch((error) => {
              this.$notification.error({
                message: "Thông báo",
                description: "Thêm cấu hình không thành công !" + error,
              });
              console.log("Không lấy được danh sách", error);
              this.iconLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },

  created() {
    this.getModulesNameReminder();
  },
};
</script>
<style></style>
